
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { OrganizationWithRelations } from "@/types/organization.types";

interface OrganizationStructureCardProps {
  organization: OrganizationWithRelations;
}

export function OrganizationStructureCard({ organization }: OrganizationStructureCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Organization Structure</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {organization.org_mapping && (
          <div>
            <span className="text-sm font-medium text-muted-foreground">Org Mapping & Stakeholders:</span>
            <p className="text-sm mt-1">{organization.org_mapping}</p>
          </div>
        )}
        
        {organization.org_chart_notes && (
          <div className="mt-3">
            <span className="text-sm font-medium text-muted-foreground">Org Chart Notes:</span>
            <p className="text-sm mt-1">{organization.org_chart_notes}</p>
            <p className="text-xs text-muted-foreground mt-1">Who's who in decision-making (and influence)</p>
          </div>
        )}
        
        {!organization.org_mapping && !organization.org_chart_notes && (
          <div className="text-sm text-muted-foreground italic">
            No organization structure information added
          </div>
        )}
      </CardContent>
    </Card>
  );
}
